export enum GanttQueryParamKey {
  VEHICLE_UUID = 'vehicleUuid',
  ORDER_UUID = 'orderUuid',
  DATE = 'date',
}
